<script setup lang="ts">
import { useMediaQuery } from '@vueuse/core'
import type { Placement } from '@popperjs/core'
// this media query is used to hide tooltips on mobile devices
// https://github.com/nuxt/ui/issues/1100#issuecomment-1946635184
const isMobile = useMediaQuery('(pointer:coarse)')

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  placement: {
    type: String as PropType<Placement>,
    default: 'bottom'
  }
})
</script>

<template>
  <UPopover
    :mode="isMobile ? 'click' : 'hover'"
    :popper="{ placement: props.placement }"
    :ui="{ trigger: 'w-auto', width: 'max-w-xs', base: 'text-wrap h-fit' }"
    role="tooltip"
    aria-hidden="true"
  >
    <slot> </slot>

    <template #panel>
      <div
        class="px-2 py-1 text-xs font-normal bg-white dark:bg-gray-900 text-gray-900 dark:text-white rounded shadow ring-1 ring-gray-200 dark:ring-gray-800"
        role="tooltip"
      >
        {{ text }}
      </div>
    </template>
  </UPopover>
</template>
